import bgSpeed from '../../assets/images/about-bg.png';
import cardBg from '../../assets/images/card_bg.png';
import ServiceButton from '../ui/ServiceButton';
import { useNavigate } from 'react-router-dom';
import { useSmoothScroll } from '../../hooks/useSmoothScroll';

function Hero() {
  const navigate = useNavigate();
  const { scrollToSection } = useSmoothScroll();

  const handleContactClick = () => {
    navigate('/');
    setTimeout(() => {
      scrollToSection('contact');
    }, 100);
  };

  return (
    <section className="relative w-full h-[70vh] overflow-visible">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-center bg-cover"
        style={{ backgroundImage: `url(${bgSpeed})` }}
      />

      {/* Overlay Card */}
   
      <div className="container mx-auto px-4 absolute -bottom-20 left-0 right-0 z-30">
        <div
          className="bg-[#F55109] bg-opacity-95 p-8 sm:p-12 max-w-3xl"
          style={{
            backgroundImage: `url(${cardBg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <p className="text-sm text-white font-semibold mb-2">ABOUT SPEEDYSSEY</p>
          <h1 className="special-header text-4xl sm:text-4xl md:text-6xl font-bold text-white leading-tight mb-4">
            DELIVERING MORE THAN JUST <br/> PACKAGES
          </h1>
          <p className="text-white text-base mb-6">
            Speedyssey is on a mission to simplify and <br/> power modern logistics for businesses.
          </p>
          <ServiceButton
                title="Contact Us"
                className="w-auto"
                variant="white"
                onClick={handleContactClick}
              />
        </div>
      </div>
    </section>
  );
}

export default Hero;
